var _rect, _rect2, _rect3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReconnectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "url(#paint0_linear_597_35257)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "url(#paint1_linear_597_35257)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7083 11.7139L18.0031 12.4279L19.1161 13.5478L20.2291 14.6678L17.7352 14.7419C15.3224 14.8135 15.2137 14.8299 14.3941 15.2453C12.7364 16.0853 11.8031 17.1815 11.2578 18.9289C10.91 20.0429 10.9139 20.949 11.271 22.1022C11.7896 23.7766 12.7102 24.8561 14.3459 25.7082L15.2412 26.1747H21.5159H27.7905L28.8445 25.6131C33.1129 23.3392 33.035 17.4443 28.7079 15.284C28.2776 15.0693 27.5514 14.8496 27.094 14.796L26.2625 14.6986L26.3052 15.76L26.3481 16.8213L26.8529 16.906C28.0929 17.1139 29.2687 18.0943 29.6519 19.2396C30.2881 21.142 29.4788 23.0083 27.6617 23.8284C26.934 24.1569 26.8596 24.161 21.5159 24.161C16.1722 24.161 16.0977 24.1569 15.37 23.8284C13.0524 22.7824 12.4101 19.7945 14.1214 18.0209C15.0173 17.0923 15.8061 16.8504 18.1622 16.7815C19.2928 16.7485 20.2177 16.7757 20.2177 16.8422C20.2177 16.9085 19.7242 17.4578 19.121 18.0628L18.0244 19.1628L18.6636 19.8279C19.0151 20.1938 19.3728 20.4932 19.4584 20.4932C19.6229 20.4932 22.8833 17.3093 23.566 16.4819C23.7871 16.2139 23.968 15.8627 23.968 15.7013C23.968 15.5154 23.1637 14.5999 21.7744 13.204C20.5677 11.9917 19.543 11 19.497 11C19.4511 11 19.0962 11.3213 18.7083 11.7139ZM12.7226 30.1573C12.1213 30.8008 12.5451 32 13.3738 32C13.915 32 14.4479 31.4649 14.4479 30.9212C14.4479 30.0128 13.3229 29.5147 12.7226 30.1573ZM18.1456 30.1406C17.3863 30.7361 17.8727 32 18.8612 32C19.6648 32 20.0792 30.787 19.4908 30.1573C19.1214 29.7619 18.636 29.7559 18.1456 30.1406ZM23.5409 30.1573C22.9378 30.8027 23.3433 32 24.1649 32C24.7307 32 25.2662 31.4754 25.2662 30.9212C25.2662 30.0128 24.1413 29.5147 23.5409 30.1573ZM28.964 30.1406C28.2133 30.7294 28.689 32 29.6601 32C30.1048 32 30.6033 31.4193 30.6033 30.9011C30.6033 30.4028 30.0932 29.8425 29.6397 29.8425C29.4772 29.8425 29.173 29.9767 28.964 30.1406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_35257",
    x1: 0,
    y1: 21.5,
    x2: 43,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_597_35257",
    x1: -5.93657,
    y1: -3.05526,
    x2: 22.2891,
    y2: 52.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63FF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CD4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconnectsIcon);
export default __webpack_public_path__ + "static/media/reconnects-icon.7802cc772e5e5039138cd4b24a5467a6.svg";
export { ForwardRef as ReactComponent };